import { SearchCriteriaBase, ListQueryParam, ListRange } from '../../../../../common';
import { LocalDate } from '../../../../models';
import { MasterDataItemStatus } from '../constants';

export type MasterDataReportItemModel = MasterDataReportAddressItemBrief | MasterDataReportCarrierItemBrief;

export class MasterDataReportItemBrief {
  id: number;
  status: MasterDataItemStatus;
  name: string;
  errorMessage: string;
  creationDate: LocalDate;

  constructor(params?: MasterDataReportItemBrief) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class MasterDataReportAddressItemBrief extends MasterDataReportItemBrief {
  extId: string;
  fullAddress: string;

  constructor(params?: MasterDataReportAddressItemBrief) {
    super(params);

    if (params) {
      Object.assign(this, params);
    }
  }
}

export class MasterDataReportCarrierItemBrief extends MasterDataReportItemBrief {
  tmsExtId: string;
  sapExtId: string;
  importAction: string;

  constructor(params?: MasterDataReportCarrierItemBrief) {
    super(params);

    if (params) {
      Object.assign(this, params);
    }
  }
}

export class MasterDataReportListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;
  [ListQueryParam.Status]: MasterDataItemStatus[] = [];

  constructor(params?: MasterDataReportListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
